// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: dynamically importing static config file for runtime configuration
const dynamicConfig = import.meta.env.DEV ? {} : await import(/* @vite-ignore */ '/static/config/overrides.js?url')

export const ConfigOverrides: Record<string, any> = {
  ...dynamicConfig.default,
}
